import { useEventBus } from '@vueuse/core';

export const tasksUpdatedBus = useEventBus<void>('tasksUpdated');
